/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ShouldReoptimizeScenarioDtoBase
 * auto generated base class for the model ShouldReoptimizeScenarioDtoModel.
 */
export const ShouldReoptimizeScenarioDtoModelBase = ModelBase
  .named('ShouldReoptimizeScenarioDto')
  .props({
    __typename: types.optional(types.literal("ShouldReoptimizeScenarioDto"), "ShouldReoptimizeScenarioDto"),
    shouldReoptimize: types.union(types.undefined, types.boolean),
    forceReoptimize: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ShouldReoptimizeScenarioDtoModelSelector extends QueryBuilder {
  get shouldReoptimize() { return this.__attr(`shouldReoptimize`) }
  get forceReoptimize() { return this.__attr(`forceReoptimize`) }
}
export function selectFromShouldReoptimizeScenarioDto() {
  return new ShouldReoptimizeScenarioDtoModelSelector()
}

export const shouldReoptimizeScenarioDtoModelPrimitives = selectFromShouldReoptimizeScenarioDto().shouldReoptimize.forceReoptimize
